// extracted by mini-css-extract-plugin
export default {"container":"style_container__VL405","btn":"style_btn__FJVw-","openedContainer":"style_openedContainer__-n8X+"};